import { useGetBrandsLogoCaeQuery } from './CaeApi'
import { useGetBrandsLogoCaasQuery } from './CaasApi'

// Facade for CMS content: consumers import from here without knowing
// which backend serves them. With REACT_APP_CMS_CAAS_ENABLED=true
// content comes from CaaS (CoreMedia 12, CaasApi), otherwise from the
// legacy CAE (CaeApi, slated for decommissioning).
export const CMS_CAAS_ENABLED =
	process.env.REACT_APP_CMS_CAAS_ENABLED === 'true'

// The flag is a build-time constant, so the hook choice is stable and
// doesn't break the rules of hooks.
export const useGetBrandsLogo = CMS_CAAS_ENABLED
	? useGetBrandsLogoCaasQuery
	: useGetBrandsLogoCaeQuery
